import {Tooltip} from "@mui/material";
import {InfoSharp} from "@mui/icons-material";
import React from "react";

const PersonConfigurationHistoryTooltip = props => {
    const {personDetails, fieldName} = props;

    if (!personDetails[fieldName]) {
        return '';
    }

    return (
        <span style={{position: "relative", zIndex: "1"}}>
            <Tooltip
                arrow
                placement='top'
                title={
                    <div>{personDetails[fieldName]}</div>
                }
                style={{fontSize: "20px"}}
            >
                <InfoSharp/>
            </Tooltip>
        </span>)
}

export default PersonConfigurationHistoryTooltip;